import {environment} from '@/config/environment';
import router from '../../router/router';
import {appConfig} from '@/config/appConfig';

export const GOOGLE_CALENDAR_PREFIX = 'google';

const getRedirectOrigin = () => {
    // Use dev url for local development (*.local domains)
    if (appConfig.isLocalDevelopment) {
        return environment.VITE_DEV_BASE_URL;
    }

    // For Zrok URLs (*.share.deskly.live), keep the original subdomain
    if (window.location.hostname.endsWith('.share.deskly.live')) {
        return window.location.origin;
    }

    return window.location.origin.replace(new RegExp(/(https:\/\/)([\w-]+)(\..+)/i), '$1app$3');
};

export const getGoogleCalendarConfig = () => ({
    url: 'https://accounts.google.com/o/oauth2/auth',
    clientId: environment.VITE_OAUTH_GOOGLE_ID,
    redirectUri: getRedirectOrigin() + router.resolve({name: 'AdminCalendarSettings'}).href,
    scope: [
        'https://www.googleapis.com/auth/userinfo.email',
        'https://www.googleapis.com/auth/admin.directory.user.readonly',
    ].join(' '),
    responseType: 'code',
    accessType: 'offline',
    approvalPrompt: 'force',
});
